import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react'

const CustomFormFilterWarningAlert = () => {
  return (
    <Alert rounded="md" status="warning">
      <AlertIcon />
      <AlertDescription>
        Para realizar sua busca, utilize acentuação correta e não insira espaço em branco no final do nome
      </AlertDescription>
    </Alert>
  )
}

export default CustomFormFilterWarningAlert
